/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
let loadModule = (arrModule, cb, cbErr) => {
	let reqFn = 'require';
	window[reqFn](arrModule, cb, cbErr );
};
export { loadModule };



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-recommender/src/js/preview/ModuleLoader.js